import { connect, getIn } from 'formik'
import { memo } from 'react'

/**
 * Use to check if multiple fields have any error and render your own message.
 * @type {React.FC<{ children: React.ComponentType<{ areAllValid: boolean, errors: Record<string, string> }>, fields: string[], formik?: import('formik').FormikContext<any> }>}
 */
const FormikErrorChecker = (props) => {
  if (!props.formik) {
    throw new Error('Must be used inside <Formik />')
  }

  /** @type {Record<string, string>} */
  const errors = {}
  let areAllValid = true
  for (const fieldName of props.fields) {
    const error =
      getIn(props.formik.touched, fieldName) &&
      getIn(props.formik.errors, fieldName)
    if (error) {
      areAllValid = false
      errors[fieldName] = error
    }
  }

  return <props.children areAllValid={areAllValid} errors={errors} />
}

export default memo(connect(FormikErrorChecker))
